import React from "react";
import Layout from "../layout/Layout";
import Banner from "../components/channel/Banner";
import IndustryLeaders from "../components/industry-leaders/industry-leaders";
import FeaturesList from "../components/channel/FeaturesList";
import Cta from "../components/channel/Cta";
import Testimonials from "../components/channel/Testimonials";

const Channel = () => {
  return (
    <Layout>
      <Banner />
      <IndustryLeaders />
      <FeaturesList />
      <Cta />
      <Testimonials />
    </Layout>
  );
};

export default Channel;

